import { render, staticRenderFns } from "./ModalCreateArea.vue?vue&type=template&id=50bddea3"
import script from "./ModalCreateArea.vue?vue&type=script&lang=js"
export * from "./ModalCreateArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports